let _apiBase = '';

/**
 * Set the API base URL for all subsequent requests.
 * Default is '' (same-origin). Set to e.g. 'http://10.1.1.4:8080'
 * for failover to a peer node.
 */
export function setApiBase(base) {
  _apiBase = (base || '').replace(/\/+$/, '');
}

export function getApiBase() {
  return _apiBase;
}

// --- Cloudflare Access auth redirect ---
// When CF Access session expires, fetch() to /api/* gets redirected cross-origin
// to the CF login page, which fails as a network-level TypeError. Only count
// those failures — NOT HTTP 4xx/5xx, which are real responses and mean the
// CF session was fine. Counting non-auth failures caused a logout/login
// ping-pong for users on flaky networks (see 2026-04-24 incident).
let _cloudAuthFails = 0;
let _cloudAuthRedirecting = false;

export function onCloudAuthSuccess() {
  _cloudAuthFails = 0;
}

export function onCloudAuthError() {
  _cloudAuthFails++;
  if (_cloudAuthFails >= 2 && !_cloudAuthRedirecting) {
    _cloudAuthRedirecting = true;
    window.location.href = '/cdn-cgi/access/logout';
  }
}

export async function getJson(path) {
  const resp = await fetch(`${_apiBase}/api${path}`, { cache: 'no-store' });
  if (!resp.ok) {
    const text = await resp.text();
    throw new Error(text || resp.statusText || 'Request failed');
  }
  return resp.json();
}

export async function postJson(path, payload) {
  const resp = await fetch(`${_apiBase}/api${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload ?? {}),
  });
  const text = await resp.text();
  let data;
  try {
    data = text ? JSON.parse(text) : {};
  } catch {
    throw new Error(text || resp.statusText || 'Request failed');
  }
  if (!resp.ok) {
    throw new Error(data?.error || resp.statusText || 'Request failed');
  }
  return data;
}
